// extracted by mini-css-extract-plugin
export default {"wrapper":"ScanQR_wrapper__nhDN7","result":"ScanQR_result__Nlfp4"};